/** Helpers for NRR benchmark calculations. */

import type { QuartileStats } from "../types/diagnostic";

/** Compute quartile statistics from a list of NRR values. */
export function computeQuartiles(values: number[]): QuartileStats | null {
  if (values.length === 0) return null;
  const sorted = [...values].sort((a, b) => a - b);
  const n = sorted.length;

  const percentile = (p: number) => {
    const idx = (p / 100) * (n - 1);
    const lo = Math.floor(idx);
    const hi = Math.ceil(idx);
    if (lo === hi) return sorted[lo];
    return sorted[lo] + (sorted[hi] - sorted[lo]) * (idx - lo);
  };

  return {
    min: sorted[0],
    q1: percentile(25),
    median: percentile(50),
    q3: percentile(75),
    max: sorted[n - 1],
    mean: values.reduce((a, b) => a + b, 0) / n,
    count: n,
  };
}

/** Determine which quartile a value falls into. 1 = top quartile (highest NRR). */
export function getQuartile(value: number, stats: QuartileStats): number {
  if (value >= stats.q3) return 1;
  if (value >= stats.median) return 2;
  if (value >= stats.q1) return 3;
  return 4;
}
